import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import lessons from './water-shop-videos.json';

export default function WaterShopTutorials({ kind }) {
  const available = lessons.filter(lesson => kind === 'apa' ? lesson.file.includes('distributie-apa') : lesson.file.includes('magazin'));
  const [selected, setSelected] = useState(0);
  const lesson = available[selected];
  const id = kind === 'apa' ? 'apa-tutoriale' : 'magazin-tutoriale';
  const name = kind === 'apa' ? 'Distribuție apă' : 'SWAN ERP + WooCommerce';
  if (!lesson) return null;
  const url = `${process.env.PUBLIC_URL || ''}/videos/apa-magazin/${lesson.file}`;
  const version = `?v=${lesson.version || 'initial'}`;
  return <div className="landing-tutorials" id={id}>
    <p className="landing-eyebrow">Învață pas cu pas</p>
    <h3>Tutoriale {name}</h3>
    <p>{kind === 'apa' ? 'O prezentare generală și trei tutoriale detaliate: contracte și tarife, apometre și citiri pe străzi, facturare în lot.' : 'Cinci tutoriale pentru SWAN ERP + WooCommerce: administrare, catalog și coș, publicarea produselor și fotografii, preluarea comenzilor în SWAN ERP și contul clientului.'}</p>
    {kind !== 'apa' && <p><a href={`${process.env.PUBLIC_URL || ''}/videos/apa-magazin/Magazin-WooCommerce-5-tutoriale.zip`} download>Descarcă toate cele 5 tutoriale (ZIP)</a></p>}
    <Row className="g-4"><Col lg={7}><div className="landing-video-panel" id={`${id}-video`}>
      <h4 aria-live="polite">{lesson.title}</h4>
      <p>{lesson.duration} min · Voce în română · {kind === 'apa' ? 'Catalog și date demonstrative' : 'Capturi demonstrative'}</p>
      <video key={url + version} controls playsInline preload="none" poster={`${url}.png${version}`} aria-label={lesson.title}>
        <source src={`${url}.mp4${version}`} type="video/mp4" />
        <track kind="subtitles" src={`${url}.vtt${version}`} srcLang="ro" label="Română" />
        Browserul nu poate reda videoclipul. <a href={`${url}.mp4${version}`}>Deschide MP4</a>.
      </video>
      <a href={`${url}.mp4${version}`} target="_blank" rel="noopener noreferrer">Deschide video separat ↗</a>
      <a className="ms-3" href={`${url}.txt${version}`} target="_blank" rel="noopener noreferrer">Citește explicațiile</a>
    </div></Col><Col lg={5}><ol className="landing-lesson-list">
      {available.map((item, index) => <li key={item.file}>
        <button type="button" className="landing-lesson-button" aria-pressed={index === selected} aria-controls={`${id}-video`} onClick={() => setSelected(index)}>{item.title}</button>
        <span className="landing-lesson-ready">{index === selected ? 'Selectat' : 'Video disponibil'} · {item.duration} min</span>
      </li>)}
    </ol></Col></Row>
  </div>;
}
